import { FilterConfig } from '../../../../model/filter';
import { Rule } from '../../../../dtos/version.dto';

export const firewallFiltersConfig: FilterConfig<Rule> = {
    searchBox: { placeholder: 'Search Firewall Rule', byFields: ['displayName', 'src', 'dst', 'service', 'application', 'profiles', 'action', 'updatedDate', 'lastUpdaterMetadata']}
};